<!--
=========================================================================================
    Sidebar subcomponent of Communication Center component.
==========================================================================================
-->

<template>
  <vs-sidebar
    parent="#communication-comp"
    class="items-no-padding"
    :click-not-close="$data.$local.clickNotClose"
    :hidden-background="$data.$local.clickNotClose"
    v-model="$data.$local.isLeftSidebarActive">
    
    <div class="px-6 pt-8 pb-2 flex flex-col">
      <!-- <h5 class="mb-6">{{ $t('communication.channels') }}</h5> -->

      <router-link tag="span" :to="''" @click.native="selectTab(0)" class="flex justify-between items-center mt-2 cursor-pointer">
        <div class="flex items-center mb-2">
          <feather-icon icon="InboxIcon"
            :svgClasses="[{'text-primary stroke-current': $data.$local.selectedPanel === 0}, 'h-6 w-6']"></feather-icon>
          <span class="text-lg ml-3"
            :class="{'text-primary stroke-current': $data.$local.selectedPanel === 0}">
            {{ $t('communication.privatemessage.title') }}
          </span>
        </div>
        <template v-if="$data.$local.newPM">
          <vs-chip class="number" color="danger">
            {{ $data.$local.unread.pm }}
            <!-- {{ totalNewMessage("pm") }} -->
          </vs-chip>
        </template>
      </router-link>

      <vs-divider></vs-divider>

      <router-link tag="span" :to="''" @click.native="selectTab(1)" class="flex justify-between items-center mt-2 cursor-pointer">
        <div class="flex items-center mb-2">
          <feather-icon icon="MessageSquareIcon"
            :svgClasses="[{'text-primary stroke-current': $data.$local.selectedPanel === 1}, 'h-6 w-6']"></feather-icon>
          <span class="text-lg ml-3"
            :class="{'text-primary stroke-current': $data.$local.selectedPanel === 1}">
            {{ $t('communication.chat.title') }}
          </span>
        </div>
        <template v-if="$data.$local.newChatUnread">
          <vs-chip class="number" color="warning">
            {{ $data.$local.unread.chat }}
            <!-- {{ totalNewMessage("chat") }} -->
          </vs-chip>
        </template>
      </router-link>

      <vs-divider></vs-divider>

      <router-link tag="span" :to="''" @click.native="selectTab(2)" class="flex justify-between items-center mt-2 cursor-pointer">
        <div class="flex items-center mb-2">
          <feather-icon icon="TrelloIcon"
            :svgClasses="[{'text-primary stroke-current': $data.$local.selectedPanel === 2}, 'h-6 w-6']"></feather-icon>
          <span class="text-lg ml-3"
            :class="{'text-primary stroke-current': $data.$local.selectedPanel === 2}">
            {{ $t('communication.webboard.title' )}}
          </span>
        </div>
        <template v-if="$data.$local.newWebboardReply">
          <vs-chip class="number" color="primary">
            {{ $data.$local.unread.webboard }}
            <!-- totalNewMessage("webboard") }} -->
          </vs-chip>
        </template>
      </router-link>

    </div>
  </vs-sidebar>
</template>

<script>
import { state, getNewUnreadMessage } from "../data";

export default {
  data() {
    return {
      $local: state.local,
    }
  },
  methods: {
    selectTab(index) {
      state.local.selectedPanel = index;
      state.local.isMessageContentActive = false;
      state.local.currentViewingMessageType = state.local.panels[index];
    },
  },
  mounted() {
    getNewUnreadMessage();
  }
}

</script>

